import * as React from "react";
import { Router } from "react-router-dom";
import { BrowserHistory, createBrowserHistory } from 'history';

interface CustomBrowserRouterProps {
    basename?: string;
    children?: React.ReactNode;
}

export const history: BrowserHistory = createBrowserHistory({ window });

/**
 * Copy of the BrowserRouter implementation from react-router v6.
 * Link to copied code: https://github.com/remix-run/react-router/blob/main/packages/react-router-dom/index.tsx#L133-L160
 * 
 * This is done to gain access to 'history' object outside of React components.
 * Specifically, we need it to handle navigation within AzureDevOps (former VSS).
 * We are subscribing to navigation changes within VssNavigation class before rendering the page.
 */
export const CustomBrowserRouter = ({
    basename,
    children
}: CustomBrowserRouterProps) => {
    const historyRef = React.useRef<BrowserHistory>();
    if (historyRef.current === null) {
        historyRef.current = history;
    }
    const [state, setState] = React.useState({
        action: history?.action,
        location: history?.location
    });

    React.useLayoutEffect(() => history.listen(setState), []);

    return (
        <Router
            basename={basename}
            // eslint-disable-next-line react/no-children-prop
            children={children}
            location={state.location}
            navigationType={state.action}
            navigator={history}
        />
    );
};